(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-details.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-details.js');

'use strict';

const Button = svs.ui.ReactButton;
const formatCurrency = svs.utils.format.Currency;
const {
  BetslipLocationNameInput,
  CharityLogo
} = svs.lyckoplatsen.components.page_play.react.components;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const {
  RadioGroup,
  ControlGroup,
  RadioButton,
  Radio,
  Form
} = svs.ui.reactForm;
const {
  useEffect,
  useState
} = React;
const {
  pinLocationAtom,
  locationConfirmedAtom,
  shouldAutoPayAtom,
  shouldPayAfterDepositAtom,
  pinLocationTypeAtom,
  isGameValidAtom,
  isProlonginationAtom,
  numberOfWeeksAtom,
  lyckoplatsenNameAtom,
  shouldDisablePayButtonAtom,
  isDefaultSubscriptionAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  locationNameAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  primaryDrawAtom,
  secondaryDrawAtom,
  firstDrawAtom,
  lastDrawAtom
} = svs.lyckoplatsen.components.shared_draws.jotai.atoms;
const {
  charityAtom
} = svs.lyckoplatsen.shared_charity.jotai.atoms;
const {
  useSetAtom,
  useAtom,
  useAtomValue,
  atom
} = jotai;
const {
  useHistory,
  useParams
} = ReactRouterDOM;
const {
  useResetPlayAtoms
} = svs.lyckoplatsen.components.page_play.react.hooks;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const {
  getDefaultLocationName
} = svs.tur.lyckoplatsen.utils;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  trackVGHOPicked
} = svs.lyckoplatsen.shared_charity;
const {
  makePayment,
  drawStartEndText,
  setupSubscription
} = svs.tur.pay_lyckoplatsen;
const hasShownBetslipAtom = atom(false);
const BetslipDetails = () => {
  const [numberOfWeeks, setNumberOfWeeks] = useAtom(numberOfWeeksAtom);
  const [shouldAutoPay, setShouldAutoPay] = useAtom(shouldAutoPayAtom);
  const [shouldPayAfterDeposit, setShouldPayAfterDeposit] = useAtom(shouldPayAfterDepositAtom);
  const [pinLocation, setPinLocation] = useAtom(pinLocationAtom);
  const [hasShownBetslip, setHasShownBetslip] = useAtom(hasShownBetslipAtom);
  const isProlongination = useAtomValue(isProlonginationAtom);
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const primaryDraw = useAtomValue(primaryDrawAtom);
  const secondaryDraw = useAtomValue(secondaryDrawAtom);
  const firstDraw = useAtomValue(firstDrawAtom);
  const lastDraw = useAtomValue(lastDrawAtom);
  const pinLocationType = useAtomValue(pinLocationTypeAtom);
  const lyckoplatsenName = useAtomValue(lyckoplatsenNameAtom);
  const shouldDisablePayButton = useAtomValue(shouldDisablePayButtonAtom);
  const locationName = useAtomValue(locationNameAtom);
  const isGameValid = useAtomValue(isGameValidAtom);
  const charity = useAtomValue(charityAtom);
  const isDefultSubscription = useAtomValue(isDefaultSubscriptionAtom);
  const resetPlayAtom = useResetPlayAtoms();
  const history = useHistory();
  const params = useParams();
  const [balance, setBalance] = useState(null);
  const hasMobileKeyboard = svs.lyckoplatsen.hooks.useMobileKeyboardDetect();
  const useAlternativeSubscriptionTexts = svs.components.targeting.isTargeted('COT_LyckoplatsenBetaldialog_BenamningPrenumeration', 'B');
  useEffect(() => {
    if (!hasShownBetslip) {
      setHasShownBetslip(true);
      svs.components.analytics.trackEvent({
        category: 'Lyckoplatsen',
        action: 'Förvald prenumeration',
        opt_label: isDefultSubscription
      });
    }
  }, [hasShownBetslip, isDefultSubscription, setHasShownBetslip]);
  useEffect(() => {
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.components.account_balance.get(true, balance => {
        setBalance(parseInt(balance, 10));
      });
    }
  }, []);
  if (params.subscriptionId) {
    setNumberOfWeeks(0);
  }
  const isSubscription = numberOfWeeks === 0;

  const shouldShowCancelVGHO = !(isProlongination && isSubscription);
  let startDate = firstDraw;
  let endDate = lastDraw;
  if (numberOfWeeks === 1) {
    const [firstOneWeek, ...rest] = svs.lyckoplatsen.shared_draws.data.allDraws.sort((a, b) => new Date(a.regCloseTime) - new Date(b.regCloseTime)).slice(0, 3);
    const lastOneWeek = rest[rest.length - 1];
    startDate = firstOneWeek;
    endDate = lastOneWeek;
  }
  const drawText = drawStartEndText({
    startDate,
    endDate,
    weeks: numberOfWeeks
  });
  let btnText;
  switch (true) {
    case isSelfService && svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w') && numberOfWeeks === 1:
      btnText = "L\xE4gg till i varukorg, ".concat(CONSTANTS.PRICE_PER_WEEK, " kr");
      break;
    case isSelfService:
      btnText = "L\xE4gg till i varukorg, ".concat(numberOfWeeks * CONSTANTS.PRICE_PER_WEEK, " kr (").concat(CONSTANTS.PRICE_PER_WEEK, " kr/vecka)");
      break;
    case isSubscription:
      if (useAlternativeSubscriptionTexts && !params.subscriptionId) {
        btnText = "Starta spel (".concat(CONSTANTS.PRICE_PER_WEEK, " kr/vecka)");
      } else {
        btnText = "".concat(params.subscriptionId ? 'Ändra' : 'Prenumerera', " (").concat(CONSTANTS.PRICE_PER_WEEK, " kr/vecka)");
      }
      break;
    default:
      btnText = 'Betala 160 kr (40 kr/vecka)';
      break;
  }
  const handleIconClick = () => {
    setPinLocation({
      lat: null,
      lng: null
    });
    setLocationConfirmed(false);
  };
  let subscriptionTitle = 'Prenumerera';
  let subscriptionText = 'Prenumerationen har ingen bindningstid och betalas månadsvis med bankkort eller autogiro.';
  let subscriptionVGHOText = 'När du startat din prenumeration väljer du en organisation du vill stötta.';
  if (useAlternativeSubscriptionTexts) {
    subscriptionTitle = 'Starta spel';
    subscriptionText = 'Ingen bindningstid och betalas månadsvis med bankkort eller autogiro.';
    subscriptionVGHOText = 'När du har startat kan du när som helst lägga till eller ändra ditt val av ideell organisation att bidra till.';
  }
  const radioButtons = [{
    value: 4,
    text: 'Spela 4 veckor',
    subText: "Totalt 12 dragningar f\xF6r 160 kr. ".concat(drawText.startEndText)
  }, {
    value: 0,
    text: subscriptionTitle,
    subText: subscriptionText
  }];
  if (svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w') && isSelfService) {
    radioButtons.unshift({
      value: 1,
      text: 'Spela 1 vecka'
    });
    radioButtons.pop();
  }
  const handlePayFinished = async function () {
    var _charity$charityId;
    let {
      wagerId,
      wasInvalidCharity
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const charityId = wasInvalidCharity ? -2 : (_charity$charityId = charity === null || charity === void 0 ? void 0 : charity.charityId) !== null && _charity$charityId !== void 0 ? _charity$charityId : -1;
    if (isSelfService) {
      setTimeout(() => {
        svs.utils.url.navigate(svs.core.urlMapping.get('startPage'));
      }, 300);
    } else {
      if (charity) {
        trackVGHOPicked(true, charity.name);
      }
      if (isProlongination && params.wagerId) {
        await svs.tur.prolongStorage.set({
          wagerId: params.wagerId,
          productId: 'lyckoplatsen'
        });
      }
      history.push("/relaterat/".concat(wagerId, "/").concat(charityId));
    }
    resetPlayAtom();
  };
  const handlePayClick = () => {
    const data = {
      isProlongination,
      numberOfWeeks,
      product: 'Lyckoplatsen',
      primaryDraw,
      secondaryDraw,
      pinLocation,
      lyckoplatsenName: lyckoplatsenName.trim(),
      pinLocationType,
      charityId: charity === null || charity === void 0 ? void 0 : charity.charityId,
      firstDraw: startDate,
      lastDraw: endDate,
      locationName,
      prolongOriginalWager: svs.lyckoplatsen.data.preloadedWager,
      isAfterDeposit: shouldPayAfterDeposit
    };
    if (isSubscription && !isSelfService) {
      setupSubscription({
        data,
        subscriptionId: params.subscriptionId,
        callback: async () => {
          resetPlayAtom();
          const subscriptionUrlKey = params.subscriptionId ? 'subscriptionChange' : 'subscriptionStart';
          const cancelUrl = encodeURIComponent(svs.utils.url.makeInternal(location.href, svs.core.urlMapping.get('lyckoplatsenHome')));
          const subscriptionPayUrl = "".concat(svs.core.urlMapping.get(subscriptionUrlKey), "?cancelUrl=").concat(cancelUrl, "&product=lyckoplatsen");
          const extraParams = {
            amount: CONSTANTS.PRICE_PER_WEEK,
            branding: 'Lyckoplatsen',
            product: 'Lyckoplatsen',
            subscription: true
          };
          if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
            var _svs, _svs$setupExtraData;
            await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
              extraData: extraParams
            }));
            svs.utils.url.navigate(subscriptionPayUrl);
            return;
          }
          svs.components.customer_login.login({
            returnNewCustomer: true,
            returnUrl: subscriptionPayUrl,
            extraParams
          });
        }
      });
    } else {
      makePayment({
        data,
        onDone: handlePayFinished
      });
    }
  };
  useEffect(() => {
    if (svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w') && isSelfService) {
      setNumberOfWeeks(4);
    }
  }, [setNumberOfWeeks]);
  useEffect(() => {
    if (shouldAutoPay) {
      handlePayClick();
      setShouldAutoPay(false);
    }
  }, [shouldAutoPay]);
  if (svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit') && shouldPayAfterDeposit) {
    if (isGameValid) {
      handlePayClick();
    }
    setShouldPayAfterDeposit(false);
  }
  const handleRadioGroupChange = value => {
    const text = value === 0 ? 'Subscription' : 'Regular';
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Toggle',
      opt_label: text
    });
    setNumberOfWeeks(value);
  };
  const handleTracking = () => {
    let action = lyckoplatsenName === getDefaultLocationName() ? 'CTA_spela' : 'CTA_spelaName';
    if (isDefultSubscription) {
      action += '_förvald';
    }
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action,
      opt_label: isSubscription ? "Prenumerera ".concat(CONSTANTS.PRICE_PER_WEEK, "kr/vecka") : "Betala ".concat(CONSTANTS.PRICE_PER_WEEK * numberOfWeeks, "kr")
    });
  };
  const SelfServiceGamePeriodPicker = () => {
    if (!svs.core.detect.feature('ft-lyckoplatsen-selfservice-1w')) {
      return React.createElement("div", {
        className: "betslip-selfservice"
      }, numberOfWeeks === 1 ? "Spela 1 vecka, ".concat(CONSTANTS.PRICE_PER_WEEK, " kr") : "Spela ".concat(numberOfWeeks, " veckor, ").concat(numberOfWeeks * CONSTANTS.PRICE_PER_WEEK, " kr (").concat(CONSTANTS.PRICE_PER_WEEK, " kr/vecka)"));
    }
    return React.createElement(ControlGroup, {
      className: "choice-radio-button"
    }, React.createElement(RadioGroup, {
      size: "200"
    }, radioButtons.map(_ref => {
      let {
        value,
        text
      } = _ref;
      return React.createElement(RadioButton, {
        key: value,
        checked: numberOfWeeks === value,
        value: value,
        name: "toggle-choice",
        onChange: () => handleRadioGroupChange(value, text)
      }, text);
    })));
  };
  const DefaultGamePeriodPicker = () => React.createElement(Form, {
    isVertical: true
  }, React.createElement(ControlGroup, {
    className: "choice-radio"
  }, radioButtons.map(_ref2 => {
    let {
      value,
      text,
      subText
    } = _ref2;
    return React.createElement(Radio, {
      key: value,
      checked: numberOfWeeks === value,
      value: value,
      name: "toggle-choice-radio",
      onChange: () => handleRadioGroupChange(value, text)
    }, React.createElement("strong", null, text), React.createElement("div", null, subText));
  })));
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "lp-betslip-details ".concat(hasMobileKeyboard ? 'has-mobile-keyboard' : '')
  }, React.createElement(IconButton, {
    className: "betslip-close",
    onClick: handleIconClick,
    title: "St\xE4ng ikon"
  }, React.createElement(Icon, {
    icon: "close"
  })), React.createElement(BetslipLocationNameInput, null), React.createElement("div", {
    className: "betslip-choice"
  }, isSelfService && React.createElement(SelfServiceGamePeriodPicker, null), !isSelfService && React.createElement(DefaultGamePeriodPicker, null), React.createElement("div", {
    className: "choice-text"
  }, React.createElement("p", null, "Tisdagar, torsdagar och s\xF6ndagar - Varje vecka."), !charity && (isSubscription ? React.createElement("div", {
    className: "betslip-vgho"
  }, subscriptionVGHOText) : React.createElement("span", {
    className: "no-padding bold"
  }, " Efter betalning v\xE4ljer du en organisation du vill st\xF6tta.")))), charity && React.createElement(React.Fragment, null, React.createElement("p", {
    className: "f-550 margin-bottom"
  }, "Ditt bidrag till en god sak"), React.createElement("div", {
    className: "betslip-charity-logo"
  }, React.createElement(CharityLogo, {
    isRemoveable: shouldShowCancelVGHO
  })))), balance !== null && !isSubscription && React.createElement("p", null, "Ditt saldo: ", formatCurrency(balance), " kr"), React.createElement(Button, {
    block: true,
    size: isSelfService ? 700 : 500,
    disabled: shouldDisablePayButton,
    className: "lp-green lp-pay-button",
    onClick: () => {
      handlePayClick();
      handleTracking();
    }
  }, btnText));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  BetslipDetails
});

 })(window);